import { render } from "./add-invoices.vue?vue&type=template&id=94e77dd8"
import script from "./add-invoices.vue?vue&type=script&lang=js"
export * from "./add-invoices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__